import React from "react"
import { Link, useParams } from "react-router-dom"
import { FiArrowLeft } from "react-icons/fi"

import MaterialsManager from "./MaterialsManager"
import QuizBuilder from "./QuizBuilder"

//Everything that sits alongside a course's lectures: downloadable materials and
//the end of course quiz. Kept off the multi step course builder so that editing
//these does not mean walking back through the whole creation flow.
const CourseExtras = () => {
  const { courseId } = useParams()

  return (
    <div>
      <Link
        to="/dashboard/my-courses"
        className="mb-6 flex items-center gap-2 text-sm text-richblack-300"
      >
        <FiArrowLeft /> Back to my courses
      </Link>

      <h1 className="mb-8 text-3xl font-medium text-richblack-5">
        Materials &amp; Quiz
      </h1>

      <div className="flex flex-col gap-8">
        <MaterialsManager courseId={courseId} />
        <QuizBuilder courseId={courseId} />
      </div>
    </div>
  )
}

export default CourseExtras
